import { forwardRef } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const SingleDatepicker = ({ date, setDate }) => {
  const StartCustomInput = forwardRef(({ value, onClick }, ref) => (
    <StyledCustomInput onClick={onClick} ref={ref}>
      {value}
    </StyledCustomInput>
  ));

  return (
    <>
      <div>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={date}
          onChange={date => setDate(date)}
          customInput={<StartCustomInput />}
        />
      </div>
    </>
  );
};

export default SingleDatepicker;

const StyledCustomInput = styled.button`
  padding: 5px 10px;
  border: solid 1px #dfdfdf;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
`;
